import { SubmitButton } from 'components/form/FormActionBar'
import useTranslate from 'modules/local/useTranslate'
import React from 'react'
import { bindQueryParam } from 'views/AppLocals/functions/routerHelper'
import { doc_removeContentById_Api } from '../../../apis'
import ApiInfoForm from '../../../components/form/ApiInfoForm'
import FieldDecorator from '../../../components/form/FieldDecorator'

export const ParagraphRemoveForm = ({
  document_id,
  paragraph_id,
  paragraph_value,
  onClose,
  renderPreview = (widget, paragraph_value) => widget,
}) => {
  const t = useTranslate()
  return (
    <ApiInfoForm
      onSuccess={() => {
        onClose()
      }}
      initialValues={{
        paragraph_id,
      }}
      disableNotify={false}
      apiInfo={doc_removeContentById_Api}
      query={bindQueryParam({ id: document_id })}>
      {({
        isSubmitting,
        dirty,
        isValid,
        values = {},
        validate,
        handleChange,
        handleSubmit,
        ...props
      }) => (
        <div className="flex flex-col space-y-3">
          <div className="italic p-1 px-3 border border-red-500 rounded-lg font-medium text-red-600">
            {`* ${t('this content will be removed')} !`}
          </div>
          <FieldDecorator label="content">
            {renderPreview(
              <div className="italic p-3 border rounded-lg">
                {paragraph_value}
              </div>,
              paragraph_value
            )}
          </FieldDecorator>

          <div className="flex w-full justify-end float-right py-3">
            <SubmitButton dirtyRequired={false} />
          </div>
        </div>
      )}
    </ApiInfoForm>
  )
}

export default ParagraphRemoveForm
